<template>
    <img
        :src="templateImage"
        class="template-image"
        alt="template"
    >
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { DashboardTemplateList } from '@/types/dashboard-template'

/* Props */
const props = defineProps<{
    template: DashboardTemplateList
}>()

/* Data */
const defaultPicture = '/img/IconDashboardTemplate.png'

/* Computed */
const templateImage = computed(() => {
    return props.template.DashboardTemplatePicture || defaultPicture
})
</script>

<style lang="scss" scoped>
.template-image {
    aspect-ratio: 16/9;
    @apply w-full object-cover;
}
</style>
